<template>
  <div class="section-parameter">
    <div class="col-left">
      <h2>Monsters</h2>
    </div>
    <div class="col-right" v-if="monsters.length > 0">
      <div v-for="monster in monsters" :key="monster.id">
        <monster :id="monster.id"></monster>
      </div>
    </div>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import monster from '@/components/settings/translations/translations_monster'

export default {
  components: { monster },
  watch: {
    site: function (site) {
      this.init()
    }
  },
  computed: {
    ...mapGetters('account', {
      site: 'currentSite',
      lang: 'defaultLang'
    }),
    ...mapGetters('monsters', {
      'monsters': 'monsters'
    })
  },
  methods: {
    ...mapActions('monsters', ['loadMonsters']),

    init () {
      if (this.site) {
        this.loadMonsters()
      }
    }
  },

  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/translations/translations_monsters.vue